import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Paper,
  Grid,
  FormHelperText,
  makeStyles,
  Typography,
  Divider,
  Box
} from '@material-ui/core';
import Swal from 'sweetalert2';
import { useRequest } from 'src/hooks';
import getURLparams from 'src/helpers/getURLparams';
import { arrangeLogs } from 'src/views/trans/Payroll/helpers';

const useStyles = makeStyles(theme => ({
  registration: {
    margin: '0 auto',
    width: '100%',
    textAlign: 'center'
  },
  paper: {
    padding: '20px',
    marginTop: '20px',
    marginBottom: '20px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  topCard: {
    width: '100%',
    height: '220px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    backgroundColor: '#f57c00',
    color: '#fff',
    padding: 0
  },

  title: {
    fontWeight: 700,
    color: '#ffffff',
    paddingTop: '20px'
  },
  glowingLink: {
    paddingLeft: '10px',
    paddingRight: '10px',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '##f57c00',
    animation: '$blink 2s infinite'
  },
  whiteBackground: {
    backgroundColor: '#ffffff'
  },
  '@keyframes blink': {
    '0%': {
      opacity: 1
    },
    '50%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  }
}));

const RegistrationForm = () => {
  const request = useRequest();
  const classes = useStyles();
  const { ixJob } = getURLparams(useLocation().search);
  const [jobsMeta, setJobsMeta] = useState({});

  const [formData, setFormData] = useState({
    lname: '',
    fname: '',
    mname: '',
    addressStreet: '',
    addressBrgy: '',
    addressCity: '',
    addressProvince: '',
    addressZIP: '',
    contactNo: '',
    email: '',
    TIN: ''
  });

  const [applicantData, setApplicantData] = useState({
    username: '',
    password: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const cdPortal = jobsMeta?.jobs?.cdPortal;
  const cdBiz = jobsMeta?.jobs?.cdBiz;
  const ixJCd = jobsMeta?.jobs?.app_ixJCd;
  const validateField = (name, value) => {
    let error = '';
    switch (name) {
      case 'addressZIP':
        if (!/^\d{4}$/.test(value)) {
          error = 'ZIP Code must be exactly 4 digits.';
        }
        break;
      case 'contactNo':
        if (!/^\+63\d{10}$/.test(value)) {
          error = 'Contact number must be in the format +63XXXXXXXXXX.';
        }
        break;
      case 'email':
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = 'Invalid email format.';
        }
        break;
      case 'password':
        if (value.length < 6) {
          error = 'Password must be at least 6 characters.';
        } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(value)) {
          error = 'Password must include uppercase, lowercase, and a number.';
        }
        break;
      default:
        break;
    }
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const handleApplicantChange = e => {
    const { name, value } = e.target;
    setApplicantData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const applicantPayload = {
        username: applicantData.username,
        LName: formData.lname,
        FName: formData.fname,
        email: formData.email,
        phone: formData.contactNo,
        ixJob: ixJob,
        sub: {
          sSub: `${formData.fname} ${formData.lname}`,
          lname: formData.lname,
          fname: formData.fname,
          ixSubParent: 829
        }
      };

      const { success, data, error } = await request.post(
        '/jobs/register',
        applicantPayload,
        {}
      );

      if (success) {
        setApplicantData(data);

        const resetLink = `/portal/${cdBiz}/${cdPortal}/reset-password/${applicantData.username}?ixJob=${ixJob}&ixJCd=${ixJCd}`;

        Swal.fire({
          title: 'Registration Successful!',
          text: 'Click OK to proceed to set up your password.',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(result => {
          if (result.isConfirmed) {
            window.location.href = `/setup?username=${
              applicantData.username
            }&link=${encodeURIComponent(resetLink)}`;
          }
        });
      } else {
        console.log(data,error)
        console.log("errors ", error?.data?.errors)
        console.log("length ", error?.data?.errors?.length)
        console.log("if ", error?.data?.errors?.length>=1)
        let errorMessage = 'An error occurred during registration.';
        if (error?.data?.errors?.length>=1) {
          console.log("in array")
          errorMessage = error?.data?.errors
            .map(obj => obj?.msg)
            .join("/n")
        }
        // throw new Error(errorMessage);
        Swal.fire('Error', errorMessage, 'error');
      }
    } catch (error) {
      // console.error('Error:', error.response || error);
      // let errorMessage = 'An error occurred during registration.';
      // if (error.response && error.response.data.validation_errors) {
      //   const validationErrors = error.response.data.validation_errors;

      //   if (validationErrors.email && validationErrors.phone) {
      //     errorMessage =
      //       'The email and contact number you provided are already registered. Please enter different details.';
      //   } else if (validationErrors.email) {
      //     errorMessage =
      //       'The email address you entered is already in use. Please use a different one.';
      //   } else if (validationErrors.phone) {
      //     errorMessage =
      //       'The contact number you entered is already associated with an existing account. Please use a different one.';
      //   } else {
      //     errorMessage = Object.values(validationErrors).join('\n');
      //   }
      // }
      let errorMessage = 'An error occurred during registration.';
      Swal.fire('Error', errorMessage, 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchJobsMeta = async () => {
    try {
      const response = await request.get(`/jobs/meta`);
      setJobsMeta(response.data);
    } catch (err) {
      console.error('Error fetching job details:', err);
    }
  };

  useEffect(() => {
    fetchJobsMeta();
  }, []);

  return (
    <Box className={classes.whiteBackground}>
      <Paper className={classes.topCard}>
        <Box display="flex" alignItems="center" p={4}>
          <img
            src={require('../JobApp/logorecruitnew.png')}
            alt="Ulap Recruit Logo"
            style={{ width: 140, marginLeft: '30px' }}
          />
          <Box
            display="flex"
            flexDirection="column"
            style={{ marginLeft: '20px' }}
          >
            <Typography variant="h1" >
              {' '}
              Ulap<b>Recruit</b>
            </Typography>
            <Typography variant="h4">
              {' '}
              Radztech Business Solutions{' '}
            </Typography>
            <Typography variant="h4">
              {' '}
              3rd Floor, S&T Building, Cauayan City, Isabela{' '}
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Container maxWidth="xxl">
        <Container className={classes.registration}>
          <Paper className={classes.paper}>
            <Typography
              variant="h1"
              align="left"
              color="primary"
              style={{ fontWeight: 'bold' }}
            >
              {' '}
              Registration Form
            </Typography>
            <Typography
              variant="h4"
              align="left"
              style={{ marginBottom: '40px' }}
            >
              {' '}
              Already have an account?
              <a
                onClick={() =>
                  (window.location.href = `/portal/${cdBiz}/${cdPortal}/login?ixJCd=${ixJCd}&ixJob=${ixJob ||
                    ''}`)
                }
                className={classes.glowingLink}
              >
                Login
              </a>
            </Typography>
            <Box
              style={{
                padding: '10px',
                borderLeft: '5px solid #f57c00',
                marginBottom: '20px'
              }}
            >
              <Typography
                variant="h3"
                align="left"
                color="primary"
                style={{ fontWeight: 'bold' }}
              >
                {/* <PersonIcon  />*/}
                Name{' '}
              </Typography>
            </Box>
            <Divider style={{ marginTop: '10px', marginBottom: '15px' }} />
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} spacing={2}>
                  <TextField
                    label="Last Name"
                    name="lname"
                    value={formData.lname}
                    onChange={handleChange}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.lname}
                    margin="normal"
                  />
                  {errors.lname && (
                    <FormHelperText error>{errors.lname}</FormHelperText>
                  )}

                  <TextField
                    label="First Name"
                    name="fname"
                    value={formData.fname}
                    onChange={handleChange}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.fname}
                    margin="normal"
                  />
                  {errors.fname && (
                    <FormHelperText error>{errors.fname}</FormHelperText>
                  )}

                  <TextField
                    label="Middle Name"
                    name="mname"
                    value={formData.mname}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    error={!!errors.mname}
                    margin="normal"
                  />
                  {errors.mname && (
                    <FormHelperText error>{errors.mname}</FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Box
                    style={{
                      padding: '10px',
                      borderLeft: '5px solid #f57c00',
                      marginBottom: '20px'
                    }}
                  >
                    <Typography
                      variant="h3"
                      color="primary"
                      align="left"
                      style={{ fontWeight: 'bold' }}
                    >
                      {/* <HomeIcon /> */}
                      Detailed Address
                    </Typography>
                  </Box>
                  <Divider
                    style={{ marginTop: '10px', marginBottom: '15px' }}
                  />
                  <TextField
                    label="Street Address"
                    name="addressStreet"
                    value={formData.addressStreet}
                    onChange={handleChange}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.addressStreet}
                    margin="normal"
                  />
                  {errors.addressStreet && (
                    <FormHelperText error>
                      {errors.addressStreet}
                    </FormHelperText>
                  )}

                  <TextField
                    label="Barangay"
                    name="addressBrgy"
                    value={formData.addressBrgy}
                    onChange={handleChange}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.addressBrgy}
                    margin="normal"
                  />
                  {errors.addressBrgy && (
                    <FormHelperText error>{errors.addressBrgy}</FormHelperText>
                  )}

                  <TextField
                    label="City"
                    name="addressCity"
                    value={formData.addressCity}
                    onChange={handleChange}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.addressCity}
                    margin="normal"
                  />
                  {errors.addressCity && (
                    <FormHelperText error>{errors.addressCity}</FormHelperText>
                  )}

                  <TextField
                    label="Province"
                    name="addressProvince"
                    value={formData.addressProvince}
                    onChange={handleChange}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.addressProvince}
                    margin="normal"
                  />
                  {errors.addressProvince && (
                    <FormHelperText error>
                      {errors.addressProvince}
                    </FormHelperText>
                  )}

                  <TextField
                    label="ZIP Code"
                    name="addressZIP"
                    value={formData.addressZIP}
                    onChange={e => {
                      const value = e.target.value
                        .replace(/\D/g, '')
                        .slice(0, 4);
                      setFormData(prev => ({ ...prev, addressZIP: value }));
                      validateField('addressZIP', value);
                    }}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.addressZIP}
                    margin="normal"
                  />
                  {errors.addressZIP && (
                    <FormHelperText error>{errors.addressZIP}</FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Box
                    style={{
                      padding: '10px',
                      borderLeft: '5px solid #f57c00',
                      marginBottom: '20px'
                    }}
                  >
                    <Typography
                      variant="h3"
                      color="primary"
                      align="left"
                      style={{ fontWeight: 'bold' }}
                    >
                      {/* <PermPhoneMsgIcon /> */}
                      Contacts
                    </Typography>
                  </Box>
                  <Divider
                    style={{ marginTop: '10px', marginBottom: '15px' }}
                  />
                  <TextField
                    label="Contact Number"
                    name="contactNo"
                    value={formData.contactNo}
                    onChange={e => {
                      let value = e.target.value.replace(/\D/g, '');
                      if (!value.startsWith('63')) value = '63' + value;
                      setFormData(prev => ({
                        ...prev,
                        contactNo: '+' + value
                      }));
                      validateField('contactNo', '+' + value);
                    }}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.contactNo}
                    margin="normal"
                  />
                  {errors.contactNo && (
                    <FormHelperText error>{errors.contactNo}</FormHelperText>
                  )}

                  <TextField
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.email}
                    margin="normal"
                  />
                  {errors.email && (
                    <FormHelperText error>{errors.email}</FormHelperText>
                  )}

                  <TextField
                    label="Username"
                    name="username"
                    value={applicantData.username}
                    onChange={handleApplicantChange}
                    fullWidth
                    required
                    variant="outlined"
                    error={!!errors.username}
                    margin="normal"
                  />
                  {errors.username && (
                    <FormHelperText error>{errors.username}</FormHelperText>
                  )}
                </Grid>
                {/* { <Grid item xs={12}>
                                    <TextField
                                        label="Password"
                                        name="password"
                                        type="password"
                                        value={applicantData.password}
                                        onChange={handleApplicantChange}
                                        fullWidth
                                        required
                                        variant="outlined"
                                        error={!!errors.password}
                                    />
                                    {errors.password && <FormHelperText error>{errors.password}</FormHelperText>}
                                </Grid>} */}
                <Grid item xs={12} className={classes.buttonContainer}>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    color="primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Processing...' : 'Register'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Container>
      </Container>
    </Box>
  );
};

export default RegistrationForm;
